import { useState } from "react";
import { Ticket, X } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { money } from "@/lib/format";

// Checkout field: check an EYW gift card code and pass it up; the server applies it (partial OK).
export const GiftCodeField = ({ value, onChange, due = null, testid = "gift-code" }) => {
  const [code, setCode] = useState(value || "");
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const check = async () => {
    setErr("");
    try {
      const { data } = await api.get(`/gift-cards/check/${encodeURIComponent(code.trim())}`);
      if (!data.usable) { setErr(data.status === "expired" ? "This gift card has expired." : "This gift card has no balance left."); return; }
      setInfo(data); onChange(data.code);
    } catch (e) { setErr(formatApiError(e.response?.data?.detail)); }
  };
  if (info) {
    const covers = due != null ? Math.min(Number(info.balance), Number(due)) : null;
    return (
      <div className="rounded-xl bg-[#5C8A72]/10 text-[#3F6B55] px-3 py-2 text-sm" data-testid={`${testid}-applied`}>
        <div className="flex items-center gap-2">
          <Ticket size={14} /> Gift card {info.code} · {money(info.balance)} available
          <button type="button" onClick={() => { setInfo(null); setCode(""); onChange(""); }} className="ml-auto" aria-label="Remove gift card" data-testid={`${testid}-remove`}><X size={14} /></button>
        </div>
        {covers != null && (
          <p className="text-xs mt-1" data-testid={`${testid}-summary`}>Covers {money(covers)} — you'll pay {money(Math.max(0, Number(due) - covers))}. Any unused balance stays on the card.</p>
        )}
      </div>
    );
  }
  return (
    <div data-testid={testid}>
      <div className="flex gap-2">
        <input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="Gift card code (EYW-…)" className="eyw-input flex-1 text-sm" data-testid={`${testid}-input`} />
        <button type="button" onClick={check} disabled={!code.trim()} className="eyw-btn-ghost !py-2 text-sm" data-testid={`${testid}-apply`}>Apply</button>
      </div>
      {err && <p className="text-xs text-red-600 mt-1" data-testid={`${testid}-error`}>{err}</p>}
    </div>
  );
};
